module.exports = __webpack_public_path__ + "img/down.51364a82.png";